import React from "react";
import ExcelJS from "exceljs";

const ExcelDownloadDemo = () => {
  const handleDownload = async () => {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Books");

    ws.columns = [
      { header: "Isbn", key: "Isbn" },
      { header: "TITLE", key: "TITLE" },
      { header: "Author", key: "Author" },
      { header: "price", key: "price" },
      { header: "Quantity", key: "Quantity" },
    ];

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Template.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <React.Fragment>
      <p className="pointer blue-underlined" onClick={handleDownload}>
        here
      </p>
    </React.Fragment>
  );
};

export default ExcelDownloadDemo;
